module.exports = "/packs/011-ee1d6748c976c5c3d4dd7679afc99b76.jpg";